import React from "react";
import {Box, ChevronUpDownIcon, CircleIcon, MenuItem, Select} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicSelectStatusIcon = () => {
  const [age, setAge] = React.useState(10);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"Select with status icon"}
        language={"js"}
        value={
          " const [age, setAge] = useState('10');\n" +
          "    const handleChange = (event: SelectChangeEvent) => {\n" +
          "        setAge(event.target.value);\n" +
          "    };\n\n\n\n" +
          "     <Select\n" +
          "          value={age}\n" +
          "          onChange={handleChange}\n" +
          "          IconComponent={ChevronUpDownIcon}\n" +
          "        >\n" +
          "          <MenuItem value={10}>\n" +
          '            <Stack direction={"row"} alignItems={"center"} spacing={1}>\n' +
          '              <CircleIcon sx={{ fontSize: 10, color: "success.main" }} />\n' +
          "              <span>Tom Cook - Default</span>\n" +
          "            </Stack>\n" +
          "          </MenuItem>\n" +
          "          <MenuItem value={20}>Tom Cook - Twenty</MenuItem>\n" +
          "          <MenuItem value={30}>Tom Cook - Thirty</MenuItem>\n" +
          "        </Select>\n" +
          "\n" +
          "<Select\n" +
          "          value={age}\n" +
          "          onChange={handleChange}\n" +
          "          IconComponent={ChevronUpDownIcon}\n" +
          "        >\n" +
          "          <MenuItem value={10} sx={{gap:1}}>\n" +
          '            <CircleIcon sx={{ fontSize: 10 }} color="success" />\n' +
          "            Tom Cook - Small\n" +
          "          </MenuItem>\n" +
          "          <MenuItem value={20}>Tom Cook - Twenty</MenuItem>\n" +
          "          <MenuItem value={30}>Tom Cook - Thirty</MenuItem>\n" +
          "        </Select>"
        }
      >
        <Select
          value={age}
          onChange={handleChange}
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10} sx={{ gap: 1 }}>
            <CircleIcon sx={{ fontSize: 10 }} color="success" />
            Tom Cook - Small
          </MenuItem>
          <MenuItem value={20}>Tom Cook - Twenty</MenuItem>
          <MenuItem value={30}>Tom Cook - Thirty</MenuItem>
        </Select>

        <Select
          value={age}
          onChange={handleChange}
          size="small"
          IconComponent={ChevronUpDownIcon}
        >
          <MenuItem value={10} sx={{ gap: 1 }}>
            <CircleIcon sx={{ fontSize: 10 }} color="success" />
            Tom Cook - Small
          </MenuItem>
          <MenuItem value={20}>Tom Cook - Twenty</MenuItem>
          <MenuItem value={30}>Tom Cook - Thirty</MenuItem>
        </Select>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicSelectStatusIcon;
